<template>
  <div class="dialog1">
    <!-- 安全生产许可证 -->
    <el-dialog
      v-if="title == '安全生产许可证' ? dialogFormVisible : false"
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '安全生产许可证' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia1"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="证件编号:" label-width="91px" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            :disabled="step == 5 || type"
            placeholder="请输入证件编号"
          />
        </el-form-item>
        <el-form-item label="单位名称: " label-width="91px" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入单位名称"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            :disabled="step == 5 || type"
            placeholder="请输入主要负责人"
          />
        </el-form-item>
        <el-form-item label="经济类型:" label-width="91px" prop="jjlx">
          <el-input
            v-model="form.jjlx"
            :disabled="step == 5 || type"
            placeholder="请输入经济类型"
          />
        </el-form-item>
        <el-form-item label="注册地址:" label-width="91px" prop="dz">
          <el-input
            v-model="form.dz"
            :disabled="step == 5 || type"
            placeholder="请输入注册地址"
          />
        </el-form-item>

        <el-form-item label="许可范围:" label-width="91px" prop="jyfw">
          <el-input
            v-model="form.jyfw"
            type="textarea"
            :rows="3"
            resize="none"
            :disabled="step == 5 || type"
            placeholder="请输入许可范围"
          />
        </el-form-item>

        <el-form-item label="有效期:" label-width="91px" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                :disabled="step == 5 || type"
                type="date"
                placeholder="选择日期"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                :disabled="step == 5 || type"
                type="date"
                placeholder="选择日期"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            :disabled="step == 5 || type"
            placeholder="请输入发证机关"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            :disabled="step == 5 || type"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="step == 5 || type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 非药品类易制毒化学品生产许可证-->
    <el-dialog
      v-if="
        title == '非药品类易制毒化学品生产许可证' ? dialogFormVisible : false
      "
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="
        title == '非药品类易制毒化学品生产许可证' ? dialogFormVisible : false
      "
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia2"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="编号:" label-width="91px" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            placeholder="请输入证件编号"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="生产品种:" prop="hxpMcs">
          <el-input
            v-model="form.hxpMcs"
            :disabled="step == 5 || type"
            placeholder="请选择"
            @focus="hxp('innerVisible1')"
          />
        </el-form-item>
        <el-form-item label="单位名称:" label-width="91px" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入单位名称"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label="经济类型:" label-width="91px" prop="jjlx">
          <el-input
            v-model="form.jjlx"
            placeholder="请输入经济类型"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label="主要流向:" label-width="91px" prop="zylx">
          <el-input
            v-model="form.zylx"
            placeholder="请输入主要流向"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            :disabled="step == 5 || type"
            placeholder="请输入主要负责人"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input
            v-model="form.dz"
            placeholder="请输入单位地址"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            placeholder="请输入发证机关"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            :disabled="step == 5 || type"
            type="date"
            placeholder="请输入发证日期"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/1）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="step == 5 || type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
          <!-- <div style="position: relative">
            <el-upload
              :headers="token"
              :disabled="step == 5 || type || closeBox"
              class="avatar-uploader"
              :show-file-list="false"
              :file-list="fileList"
              :action="returnSaveFile"
              :on-success="handleAvatarSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :on-change="handleprogress"
            >
              <el-image
                v-if="closeBox"
                style="width: 96px; height: 96px"
                :src="imageurlone"
                :fit="imageurlone"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div
              v-show="closeBox && !type"
              class="deleteUpload"
                 v-preventReClick   @click="removeCurImg()"
            >
              <i class="el-icon-circle-close" />
            </div>
          </div>

          <el-dialog
    :close-on-click-modal=false
  :closeOnPressEscape=false
 append-to-body :visible.sync="dialogVisible" class="yulan">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog> -->
        </el-form-item>
      </el-form>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        :visible.sync="innerVisible1"
        append-to-body
        center
        :show-close="false"
      >
        <div style="overflow: auto; height: 100%">
          <el-tree
            ref="dataTree"
            :data="HxpTree"
            show-checkbox
            node-key="value"
            :props="defaultProps"
            @check-change="handleCheckChange"
            @node-click="nodeClick"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-preventReClick @click="treeQ('qx')">取 消</el-button>
          <el-button
            v-preventReClick
            type="primary"
            @click="treeQ"
          >确 定</el-button>
        </span>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 非药品类易制毒化学品生产备案证明 -->
    <el-dialog
      v-if="
        title == '非药品类易制毒化学品生产备案证明' ? dialogFormVisible : false
      "
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="
        title == '非药品类易制毒化学品生产备案证明' ? dialogFormVisible : false
      "
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia3"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label-width="91px" label="编号:" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            placeholder="请输入证件编号"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="品种类别:" prop="pzlb">
          <el-input
            v-model="form.pzlb"
            placeholder="请输入品种类别"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入单位名称"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="生产品种:" prop="hxpMcs">
          <el-input
            v-model="form.hxpMcs"
            :disabled="step == 5 || type"
            placeholder="请输入生产品种"
            @focus="hxp('innerVisible2')"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经济类型:" prop="jjlx">
          <el-input
            v-model="form.jjlx"
            placeholder="请输入经济类型"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="主要流向:" prop="zylx">
          <el-input
            v-model="form.zylx"
            placeholder="请输入主要流向"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            :disabled="step == 5 || type"
            placeholder="请输入主要负责人"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            placeholder="请输入发证机关"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input
            v-model="form.dz"
            placeholder="请输入单位地址"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                :disabled="step == 5 || type"
                placeholder="选择日期"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                :disabled="step == 5 || type"
                placeholder="选择日期"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            :disabled="step == 5 || type"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/1）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="step == 5 || type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>

          <!-- <div style="position: relative">
            <el-upload
              :headers="token"
              :disabled="step == 5 || type || closeBox"
              class="avatar-uploader"
              :show-file-list="false"
              :file-list="fileList"
              :action="returnSaveFile"
              :on-success="handleAvatarSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :on-change="handleprogress"
            >
              <el-image
                v-if="closeBox"
                style="width: 96px; height: 96px"
                :src="imageurlone"
                :fit="imageurlone"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div
              v-show="closeBox && !type"
              class="deleteUpload"
                 v-preventReClick   @click="removeCurImg()"
            >
              <i class="el-icon-circle-close" />
            </div>
          </div>

          <el-dialog
    :close-on-click-modal=false
  :closeOnPressEscape=false
 append-to-body :visible.sync="dialogVisible" class="yulan">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog> -->
        </el-form-item>
      </el-form>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        :visible.sync="innerVisible2"
        append-to-body
        center
        :show-close="false"
      >
        <div style="overflow: auto; height: 100%">
          <el-tree
            ref="dataTree"
            :data="HxpTree"
            show-checkbox
            node-key="value"
            :props="defaultProps"
            @check-change="handleCheckChange"
            @node-click="nodeClick"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-preventReClick @click="treeQ('qx')">取 消</el-button>
          <el-button
            v-preventReClick
            type="primary"
            @click="treeQ"
          >确 定</el-button>
        </span>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 非药品类易制毒化学品经营许可证4-->
    <el-dialog
      v-if="
        title == '非药品类易制毒化学品经营许可证' ? dialogFormVisible : false
      "
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="
        title == '非药品类易制毒化学品经营许可证' ? dialogFormVisible : false
      "
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia3"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            placeholder="请输入证件编号"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item
          label-width="137px"
          label="统一社会信用代码:"
          prop="tyshxydm"
        >
          <el-input
            v-model="form.tyshxydm"
            placeholder="请输入"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经营品种:" prop="pzcl">
          <el-input
            v-model="form.pzcl"
            :disabled="step == 5 || type"
            placeholder="请选择化学品"
            @focus="hxp('innerVisible4')"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入单位名称"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经济类型:" prop="jjlx">
          <el-input
            v-model="form.jjlx"
            placeholder="请输入经济类型"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            placeholder="请输入主要负责人"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="主要流向:" prop="zylx">
          <el-input
            v-model="form.zylx"
            placeholder="请输入主要流向"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            placeholder="请输入发证机关"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input
            v-model="form.dz"
            placeholder="请输入单位地址"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                :disabled="step == 5 || type"
                placeholder="选择日期"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                :disabled="step == 5 || type"
                placeholder="选择日期"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            :disabled="step == 5 || type"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/1）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="step == 5 || type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
          <!-- <div class="fujian">上传附件（{{ fileList.length }}/1）</div>
          <div style="position: relative">
            <el-upload
              :headers="token"
              :disabled="step == 5 || type || closeBox"
              class="avatar-uploader"
              :show-file-list="false"
              :file-list="fileList"
              :action="returnSaveFile"
              :on-success="handleAvatarSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :on-change="handleprogress"
            >
              <el-image
                v-if="closeBox"
                style="width: 96px; height: 96px"
                :src="imageurlone"
                :fit="imageurlone"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div
              v-show="closeBox && !type"
              class="deleteUpload"
                 v-preventReClick   @click="removeCurImg()"
            >
              <i class="el-icon-circle-close" />
            </div>
          </div>

          <el-dialog
    :close-on-click-modal=false
  :closeOnPressEscape=false
 append-to-body :visible.sync="dialogVisible" class="yulan">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog> -->
        </el-form-item>
      </el-form>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        :visible.sync="innerVisible4"
        append-to-body
        center
        :show-close="false"
      >
        <div style="overflow: auto; height: 100%">
          <el-tree
            ref="dataTree"
            :data="HxpTree"
            show-checkbox
            node-key="value"
            :props="defaultProps"
            @check-change="handleCheckChange"
            @node-click="nodeClick"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="treeQ('qx')">取 消</el-button>
          <el-button type="primary" @click="treeQ">确 定</el-button>
        </span>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 危险化学品经营许可证5 -->
    <el-dialog
      v-if="title == '危险化学品经营许可证' ? dialogFormVisible : false"
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '危险化学品经营许可证' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia5"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            placeholder="请输入证件编号"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入单位名称"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位住所:" prop="dz">
          <el-input
            v-model="form.dz"
            placeholder="请输入单位住所"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label="法定代表人/负责人:" prop="fzr" label-width="140px">
          <el-input
            v-model="form.fzr"
            placeholder="请输入"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="经营方式:" prop="jjlx">
          <el-input
            v-model="form.jjlx"
            placeholder="请输入经营方式"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            placeholder="请输入发证机关"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="许可范围:" prop="jyfw">
          <el-input
            v-model="form.jyfw"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入许可范围"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            :disabled="step == 5 || type"
            placeholder="请选择发证日期"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label-width="115px" label="有效期延续至:" prop="yxqyxz">
          <el-date-picker
            v-model="form.yxqyxz"
            type="date"
            placeholder="请选择"
            style="width: 174px"
            :disabled="step == 5 || type"
            :picker-options="pickerOptions1"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :disabled="step == 5 || type"
            :headers="token"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 非药品类易制毒化学品经营备案证明6 -->
    <el-dialog
      v-if="
        title == '非药品类易制毒化学品经营备案证明' ? dialogFormVisible : false
      "
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="
        title == '非药品类易制毒化学品经营备案证明' ? dialogFormVisible : false
      "
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia6"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            placeholder="请输入证件编号"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入单位名称"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label="主要负责人:" prop="fzr" label-width="91px">
          <el-input
            v-model="form.fzr"
            placeholder="请输入主要负责人"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="135px" label="统一社会信用代码:">
          <el-input
            v-model="form.tyshxydm"
            placeholder="请输入"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="品种类别:" prop="pzlb">
          <el-input
            v-model="form.pzlb"
            placeholder="请输入"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经营品种:" prop="hxpMcs">
          <el-input
            v-model="form.hxpMcs"
            :disabled="step == 5 || type"
            placeholder="请输入"
            @focus="hxp('innerVisible3')"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经济类型:" prop="jjlx">
          <el-input
            v-model="form.jjlx"
            placeholder="请输入经济类型"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="主要流向:" prop="zylx">
          <el-input
            v-model="form.zylx"
            placeholder="请输入主要流向"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="单位地址:" prop="dz">
          <el-input
            v-model="form.dz"
            placeholder="请输入单位地址"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                :disabled="step == 5 || type"
                placeholder="选择日期"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            placeholder="请输入发证机关"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            :disabled="step == 5 || type"
            placeholder="请输入发证日期"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/1）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="step == 5 || type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>

          <!-- <div class="fujian">上传附件（{{ fileList.length }}/1）</div>
          <div style="position: relative">
            <el-upload
              :headers="token"
              :disabled="step == 5 || type || closeBox"
              class="avatar-uploader"
              :show-file-list="false"
              :file-list="fileList"
              :action="returnSaveFile"
              :on-success="handleAvatarSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :on-change="handleprogress"
            >
              <el-image
                v-if="closeBox"
                style="width: 96px; height: 96px"
                :src="imageurlone"
                :fit="imageurlone"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div
              v-show="closeBox && !type"
              class="deleteUpload"
                 v-preventReClick   @click="removeCurImg()"
            >
              <i class="el-icon-circle-close" />
            </div>
          </div>

          <el-dialog
    :close-on-click-modal=false
  :closeOnPressEscape=false
 append-to-body :visible.sync="dialogVisible" class="yulan">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog> -->
        </el-form-item>
      </el-form>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        :visible.sync="innerVisible3"
        append-to-body
        center
        :show-close="false"
      >
        <div style="overflow: auto; height: 100%">
          <el-tree
            ref="dataTree"
            :data="HxpTree"
            show-checkbox
            node-key="value"
            :props="defaultProps"
            @check-change="handleCheckChange"
            @node-click="nodeClick"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="treeQ('qx')">取 消</el-button>
          <el-button type="primary" @click="treeQ">确 定</el-button>
        </span>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--道路运输经营许可证7 -->
    <el-dialog
      v-if="title == '道路运输经营许可证' ? dialogFormVisible : false"
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '道路运输经营许可证' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia7"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            placeholder="请输入证件编号"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="业户名称:" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="地址:" prop="dz">
          <el-input
            v-model="form.dz"
            placeholder="请输入地址"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经营范围:" prop="jyfw">
          <el-input
            v-model="form.jyfw"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入经营范围"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="核发机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            placeholder="请输入核发机关"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="核发日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入核发日期"
            :disabled="step == 5 || type"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="step == 5 || type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--其他证件8-->
    <el-dialog
      v-if="title == '其他证件' ? dialogFormVisible : false"
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '其他证件' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia8"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label-width="91px" label="证件名称:" prop="zsmc">
          <el-input
            v-model="form.zsmc"
            placeholder="请输入"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            placeholder="请输入证件编号"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            placeholder="请输入发证机关"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            :disabled="step == 5 || type"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :disabled="step == 5 || type"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--合法使用需要证明9 -->
    <el-dialog
      v-if="title == '合法使用需要证明' ? dialogFormVisible : false"
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '合法使用需要证明' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia9"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label-width="91px" label="单位名称:" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入单位名称"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="化学品:" prop="hxpMcs">
          <el-input
            v-model="form.hxpMcs"
            :disabled="step == 5 || type"
            placeholder="请输入化学品"
            @focus="hxp('innerVisible')"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="涉及量:" prop="sjl">
          <el-input
            v-model="form.sjl"
            placeholder="请输入涉及量"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="签订日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入签订日期"
            style="width: 174px"
            :disabled="step == 5 || type"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :disabled="step == 5 || type"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>

          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        :visible.sync="innerVisible"
        append-to-body
        center
        :show-close="false"
      >
        <div style="overflow: auto; height: 100%">
          <el-tree
            ref="dataTree"
            :data="HxpTree"
            show-checkbox
            node-key="value"
            :props="defaultProps"
            @check-change="handleCheckChange"
            @node-click="nodeClick"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-preventReClick @click="treeQ('qx')">取 消</el-button>
          <el-button
            v-preventReClick
            type="primary"
            @click="treeQ"
          >确 定</el-button>
        </span>
      </el-dialog>

      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 危险货物道路运输许可证 -->
    <el-dialog
      v-if="title == '危险货物道路运输许可证' ? dialogFormVisible : false"
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible="title == '危险货物道路运输许可证' ? dialogFormVisible : false"
      center
      :show-close="false"
      append-to-body
      custom-class="zhengjia10"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label-width="91px" label="证件编号:" prop="zjbh">
          <el-input
            v-model="form.zjbh"
            placeholder="请输入证件编号"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="业户名称:" prop="dwmc">
          <el-input
            v-model="form.dwmc"
            placeholder="请输入"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="地址:" prop="dz">
          <el-input
            v-model="form.dz"
            placeholder="请输入地址"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经营范围:" prop="jyfw">
          <el-input
            v-model="form.jyfw"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入经营范围"
            :disabled="step == 5 || type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="form.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.startTime(form.yxqJs)"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="form.yxqJs"
                type="date"
                placeholder="选择日期"
                :disabled="step == 5 || type"
                :picker-options="this.endTime(form.yxqKs)"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="form.fzjg"
            placeholder="请输入发证机关"
            :disabled="step == 5 || type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="form.fzrq"
            type="date"
            placeholder="请输入发证日期"
            :disabled="step == 5 || type"
            style="width: 174px"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item>
          <div class="fujian">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="step == 5 || type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="closeDialog('form')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitForm('form')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  url1,
  saveFjMes,
  getToken,
  returnSaveFile,
  returnShowPic,
  getFjTableMes,
  getHxpTree
} from '@/assets/js/common.js'
import { startTime, endTime, lengthValidate } from '@/assets/js/validate.js'
export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: {}
    },
    type: {
      type: Boolean
    },
    title: {
      type: String,
      default: {}
    },
    step: {
      type: Number,
      default: {}
    },
    zjlx: {
      // 证件类型
      type: Number,
      default: {}
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          return time > Date.now()
        }
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '永久日期',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      loading: false,
      innerVisible: false, // 化学品数
      innerVisible1: false, // 非药品类易制毒化学品生产许可证
      innerVisible2: false, // 非药品类易制毒化学品生产备案证明
      innerVisible3: false, // 非药品类易制毒化学品经营备案证明
      innerVisible4: false, // 非药品类易制毒化学品经营许可证
      HxpTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      token: {
        Authorization: getToken()
      },
      returnSaveFile: '', // 保存图片
      returnShowPic: '', // 回显图片
      URL1: '',
      dialogImageUrl: '', // uploaded组件自带
      dialogVisible: false, // uploaded组件自带
      fileList: [], // uploaded组件自带
      imageUrl: '',
      imglist: [], // 存取开始的图片
      addFjxxs: [], // 添加的图片
      delFjxxs: [], // 删除的图片id
      id: '', // 根据唯一id修改值
      length: 0, // 弹框的高度跟随数量变化
      form: {
        hxpIds: '', // "化学品编码，多个逗号分隔",
        hxpMcs: '', // "化学品，多个逗号分隔",
        jyfw: '', // "（许可）经营范围",
        zzdj: '', // "资质等级",
        pzlb: '', // "品种类别",
        zsmc: '', // "证书名称",
        zjnr: '', // "证件内容",
        sjl: '', // "涉及量",
        yxqyxz: '',
        tyshxydm: '', // "统一社会信用代码",
        status: '',
        zjbh: '', // 编号
        pzcl: '', // 生产,经营（品种,产量）
        dwmc: '', // 单位名称
        zylx: '', // 主要流向
        jjlx: '', // 经济类型
        fzr: '', // 主要负责人
        dz: '', // 单位地址
        yxqKs: '', // 有效期
        yxqJs: '', // 有效期
        fzjg: '', // 发证机关
        fzrq: '' // 发证日期
      },
      rules: {
        zjbh: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100)
            },
            trigger: ['blur', 'change']
          }
        ],
        pzcl: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 500)
            },
            trigger: ['blur', 'change']
          }
        ],
        dwmc: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        zylx: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 500)
            },
            trigger: ['blur', 'change']
          }
        ],
        jjlx: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        fzr: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        dz: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 600)
            },
            trigger: ['blur', 'change']
          }
        ],
        yxqKs: [{ required: true, message: '请选择时间', trigger: 'blur' }],
        yxqJs: [{ required: true, message: '请选择时间', trigger: 'blur' }],
        fzjg: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        fzrq: [{ required: true, message: '请选择发证日期', trigger: 'blur' }],
        hxpIds: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        hxpMcs: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 500)
            },
            trigger: ['blur', 'change']
          }
        ],
        jyfw: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 3000)
            },
            trigger: ['blur', 'change']
          }
        ],
        zzdj: [{ required: true, message: '请输入', trigger: 'blur' }],
        pzlb: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        zsmc: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        zjnr: [{ required: true, message: '请输入', trigger: 'blur' }],
        sjl: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100)
            },
            trigger: ['blur', 'change']
          }
        ],
        tyshxydm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100)
            },
            trigger: ['blur', 'change']
          }
        ]
        // yxqyxz: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      imageurlone: '',
      closeBox: false
    }
  },
  watch: {
    'fileList.length': {
      deep: true,
      handler(val) {
        if (
          this.fileList.length >= 6 ||
          this.type ||
          (this.title.includes('非药品类易制毒化学品') &&
            this.fileList.length > 0)
        ) {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'none'
        } else {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'inline-block'
        }
      }
    }
  },
  created() {
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    // 化学品树
    getHxpTree().then((e) => {
      this.HxpTree = e.data.data
    })
  },
  mounted() {},
  methods: {
    lengthValidate,
    startTime,
    endTime,
    hxp(name) {
      this[name] = true
      this.xshxp()
    },
    xshxp() {
      this.$nextTick(() => {
        if (this.form.hxpIds) {
          this.$refs.dataTree.setCheckedKeys(
            this.form.hxpIds.split(',').map(Number)
          )
        }
      })
    },

    handleCheckChange(data, checked, indeterminate) {
      if (checked && this.innerVisible && !data.children) {
        this.$refs.dataTree.setCheckedKeys([data.value])
      }
    },
    nodeClick(data, checked, node) {
      if (!data.children) {
        this.$refs.dataTree.setChecked(data.value, !checked.checked)
      }
    },
    treeQ(type) {
      if (type != 'qx') {
        const node = this.$refs.dataTree.getCheckedNodes(true)
        if (node.length > 0) {
          this.form.hxpIds = node
            .map((item, index, arr) => {
              return item.value
            })
            .toString()
          this.form.hxpMcs = node
            .map((item, index, arr) => {
              return item.label
            })
            .toString()
          this.form.pzcl = this.form.hxpMcs
        } else {
          this.form.hxpIds = ''
          this.form.hxpMcs = ''
          this.form.pzcl = ''
        }
      }
      this.innerVisible = false
      this.innerVisible1 = false
      this.innerVisible2 = false
      this.innerVisible3 = false
      this.innerVisible4 = false
      this.$refs.dataTree.setCheckedKeys([])
    },
    csh(dataMes) {
      this.form = Object.assign(
        {},
        {
          hxpIds: dataMes.dwfjSjxxDto.hxpIds, // "化学品编码，多个逗号分隔",
          hxpMcs: dataMes.dwfjSjxxDto.hxpMcs, // "化学品，多个逗号分隔",
          jyfw: dataMes.dwfjSjxxDto.jyfw, // "（许可）经营范围",
          zzdj: dataMes.dwfjSjxxDto.zzdj, // "资质等级",
          pzlb: dataMes.dwfjSjxxDto.pzlb, // "品种类别",
          zsmc: dataMes.dwfjSjxxDto.zsmc, // "证书名称",
          zjnr: dataMes.dwfjSjxxDto.zjnr, // "证件内容",
          sjl: dataMes.dwfjSjxxDto.sjl, // "涉及量",
          yxqyxz: dataMes.dwfjSjxxDto.yxqyxz,
          tyshxydm: dataMes.dwfjSjxxDto.tyshxydm, // "统一社会信用代码",
          status: dataMes.dwfjSjxxDto.status,
          id: dataMes.dwfjSjxxDto.id, // 主键
          zjbh: dataMes.dwfjSjxxDto.zjbh, // 编号
          pzcl: dataMes.dwfjSjxxDto.pzcl, // 生产,经营（品种,产量）
          dwmc: dataMes.dwfjSjxxDto.dwmc, // 单位名称
          zylx: dataMes.dwfjSjxxDto.zylx, // 主要流向
          jjlx: dataMes.dwfjSjxxDto.jjlx, // 经济类型
          fzr: dataMes.dwfjSjxxDto.fzr, // 主要负责人
          dz: dataMes.dwfjSjxxDto.dz, // 单位地址
          yxqKs: dataMes.dwfjSjxxDto.yxqKs, // 有效期
          yxqJs: dataMes.dwfjSjxxDto.yxqJs, // 有效期
          fzjg: dataMes.dwfjSjxxDto.fzjg, // 发证机关
          fzrq: dataMes.dwfjSjxxDto.fzrq // 发证日期
        }
      )
      this.id = dataMes.dwfjSjxxDto.id // 获取id修改时根据id修改此条信息

      this.imglist = []
      this.fileList = []
      dataMes.dwfjDtos.forEach((item) => {
        this.imglist.push({
          url: this.returnShowPic + item.wjdz,
          id: item.id
        })
        this.imageurlone = this.returnShowPic + item.wjdz
      })
      this.fileList = this.imglist
      if (this.title.includes('非药品类易制毒化学品')) this.closeBox = true
      else {
        // if (this.type || this.step == 5)
        //   document.getElementsByClassName(
        //     "el-upload--picture-card"
        //   )[0].style.display = "none";
      }
    },

    // 确定许可证验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && (this.length > 0 || this.imglist.length > 0)) {
          var dataobj = {
            dwfjSjxxDto: {
              id: this.id || '',
              zjlx: this.zjlx.toString() || '',
              zjbh: this.form.zjbh || '',
              jjlx: this.form.jjlx || '',
              dwmc: this.form.dwmc || '',
              dz: this.form.dz || '',
              fzr: this.form.fzr || '',
              zylx: this.form.zylx || '',
              pzcl: this.form.pzcl || '',
              yxqKs: this.form.yxqKs || '',
              yxqJs: this.form.yxqJs || '',
              fzrq: this.form.fzrq || '',
              fzjg: this.form.fzjg || '',
              dwlx: this.form.dwlx || '',
              jyfw: this.form.jyfw || '',
              zzdj: this.form.zzdj || '',
              hxpIds: this.form.hxpIds || '',
              hxpMcs: this.form.hxpMcs || '',
              pzlb: this.form.pzlb || '',
              zsmc: this.form.zsmc || '',
              zjnr: this.form.zjnr || '',
              sjl: this.form.sjl || '',
              yxqyxz: this.form.yxqyxz || '',
              tyshxydm: this.form.tyshxydm || '',
              status: this.form.status || ''
            },
            dwfjDtos: this.addFjxxs,
            delFjDtos: this.delFjxxs
          }

          this.loading = true
          this.type == true
            ? this.reset('form')
            : saveFjMes(dataobj, this.$store.state.RWLCType).then((res) => {
              this.loading = false
              getFjTableMes(
                this.$store.state.RWLCType,
                this.zjlx.toString()
              ).then((e) => {
                this.$emit('getFjTableMess', e.data.data)
                this.reset('form')
                this.$message.success('保存成功')
              })
            }).catch((error) => {
              this.loading = false
            })
        } else {
          if (this.length == 0 && this.imglist.length == 0) { this.$message.error('证件未上传') }
          return false
        }
      })
    },
    reset(formName) {
      this.loading = false
      this.$nextTick(() => {
        this.resetForm()
        this.$emit('close-dialog')
      })
      this.fileList = []
      this.addFjxxs = []
      this.delFjxxs = []
      this.imglist = []
      this.id = '' // 获取id修改时根据id修改此条信息
      this.length = 0
      this.closeBox = false
      this.imageurlone = ''
      if (this.$refs.dataTree != undefined) { this.$refs.dataTree.setCheckedKeys([]) }
    },
    // 清空form所有数据
    resetForm() {
      this.form.hxpIds = ''
      this.form.hxpMcs = ''
      this.form.pzcl = ''
      this.form = {
        hxpIds: '', // "化学品编码，多个逗号分隔",
        hxpBms: '', // "化学品编码，多个逗号分隔",
        hxpMcs: '', // "化学品，多个逗号分隔",
        jyfw: '', // "（许可）经营范围",
        zzdj: '', // "资质等级",
        pzlb: '', // "品种类别",
        zsmc: '', // "证书名称",
        zjnr: '', // "证件内容",
        sjl: '', // "涉及量",
        yxqyxz: '',
        tyshxydm: '', // "统一社会信用代码",
        status: 0,
        zjbh: '', // 编号
        pzcl: '', // 生产,经营（品种,产量）
        dwmc: '', // 单位名称
        zylx: '', // 主要流向
        jjlx: '', // 经济类型
        fzr: '', // 主要负责人
        dz: '', // 单位地址
        yxqKs: '', // 有效期
        yxqJs: '', // 有效期
        fzjg: '', // 发证机关
        fzrq: '' // 发证日期
      }
    },
    // 关闭许可证弹窗
    closeDialog(formName) {
      this.reset(formName)
    },
    // 成功
    handleAvatarSuccess(res, file) {
      this.addFjxxs.push({
        zjlx: this.zjlx,
        wjdz: res.data.url
      })
      if (this.title.includes('非药品类易制毒化学品')) {
        this.imageurlone = this.returnShowPic + res.data.url
        this.closeBox = true
      }
    },
    // 文件列表移除文件时
    handleRemove(file, fileList) {
      this.fileList = fileList
      // file包含id时，将删除主键存取
      if (file.id) {
        this.delFjxxs.push({
          id: file.id
        })
      } else {
        if (file.url.includes(this.returnShowPic)) {
          this.addFjxxs.filter((item, index) => {
            if (item.wjdz == file.url.split('=')[1]) { this.addFjxxs.splice(index, 1) }
            return
          })
        }
        // 新上传未回显
        else if (file.response) {
          this.addFjxxs.filter((item, index) => {
            if (item.wjdz == file.response.data.url) { this.addFjxxs.splice(index, 1) }
            return
          })
        }

        // 删除的为未提交过得文件
        // var indeximage = this.addFjxxs.forEach((item, index) => {
        //   if (item.wjdz == file.response.data.url) return index;
        // });
        // this.addFjxxs.splice(indeximage, 1);
      }
      this.length = this.fileList.length
      this.imglist = []
    },
    removeCurImg(type) {
      this.closeBox = false
      this.imageurlone = ''
      this.fileList = []
      this.length = this.fileList.length
      if (this.imglist[0]) {
        this.delFjxxs.push({
          id: this.imglist[0].id
        })
      }
      this.addFjxxs = []
      this.imglist = []
    },
    // 文件超出个数限制时
    handleExceed(files, fileList) {
      this.$message.warning(
        `本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件，超过限制个数`
      )
    },
    // 上传前校验文件类型和大小
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isLt2M = file.size / 1024 < 500
      const typeTrue = fileType.includes(file.type)
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      if (!typeTrue) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      return typeTrue && isLt2M
    },
    // 文件改变时
    handleprogress(file, fileList) {
      if (this.closeBox) {
        this.fileList = fileList.slice(-1)
      } else this.fileList = fileList
      this.length = this.fileList.length
    },
    // 点击文件列表中已上传的文件，预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-tree .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner {
  display: inline-block;
}
/deep/.el-tree .el-tree-node .el-checkbox .el-checkbox__inner {
  display: none;
}
.deleteUpload {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0;
  top: -24px;
  cursor: pointer;
}
/deep/.zhengjia1,
/deep/.zhengjia2,
/deep/.zhengjia3,
/deep/.zhengjia4,
/deep/.zhengjia5,
/deep/.zhengjia6,
/deep/.zhengjia7,
/deep/.zhengjia8,
/deep/.zhengjia9,
/deep/.zhengjia10 {
  border-radius: 5px;
  width: 1136px;
  margin-top: 5vh !important;
  .el-dialog__title {
    display: block;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    margin: 30px auto 42px;
  }
  .el-dialog__body {
    padding: 0 112px !important;
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-textarea__inner {
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .el-form-item {
        margin-bottom: 20px;
        .el-input {
          width: 340px;
          height: 39px;
        }
        .el-form-item__label {
          padding-right: 6px;
        }
        & > :last-child {
          margin-left: 21px;
        }
      }
    }
  }
  .el-dialog__footer {
    padding: 10px 20px 83px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 174px !important;
    // width: 100% !important;
  }
}
/deep/.zhengjia1 {
  .el-form-item {
    //注册地址
    &:nth-child(5) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    //许可范围
    &:nth-child(6) {
      width: 100%;
      .el-input {
        width: 100%;
      }
    }
    //有效期
    &:nth-child(7) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }
    //发证日期
    &:nth-child(9) {
      width: 100%;
    }
  }
}
/deep/.zhengjia2 {
  .el-form-item {
    //单位地址
    &:nth-child(7) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    //有效期
    &:nth-child(8) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }
    // 发证日期
    &:nth-child(10) {
      width: 100%;
    }
  }
}
/deep/.zhengjia3 {
  .el-form-item {
    //单位地址
    &:nth-child(9) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    //有效期
    &:nth-child(10) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }
    // 发证日期
    &:nth-child(11) {
      width: 47%;
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }
}
/deep/.zhengjia5 {
  .el-form-item {
    //许可范围
    &:nth-child(7) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    //有效期
    &:nth-child(8) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(9),
    &:nth-child(10) {
      width: 50%;
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }
}
/deep/.zhengjia6 {
  .el-form-item {
    //有效期
    &:nth-child(10) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(9) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    &:nth-child(12) {
      width: 100%;
    }
  }
}
/deep/.zhengjia7,
/deep/.zhengjia10 {
  .el-form-item {
    //有效期
    &:nth-child(5) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(3),
    &:nth-child(4) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }

    &:nth-child(7) {
      width: 100%;
    }
  }
}
/deep/.zhengjia8 {
  .el-form-item {
    //有效期
    &:nth-child(3) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(5) {
      width: 100%;
    }

    &:nth-child(7) {
      width: 100%;
    }
  }
}
/deep/.zhengjia9 {
  .el-form-item {
    &:nth-child(4) {
      width: 47.5%;
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }
}

/deep/.avatar-uploader .el-upload {
  border: 0 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader {
  height: 96px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px !important;
  height: 96px !important;
  line-height: 96px !important;
  text-align: center;
  background: #f3f3f3;
  border-radius: 3px;
}
/deep/.el-upload {
  line-height: 96px !important;
}
.avatar {
  display: block;
}
/deep/.el-upload-list--picture-card .el-upload-list__item,
/deep/.el-upload--picture-card {
  width: 96px !important;
  height: 96px !important;
}
.fujian {
  // width: 124px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  margin-bottom: 25px;
}
.el-button {
  margin: 0 40px;
}
.el-button--primary {
  background: #4170ff !important;
}
.yulan .el-dialog {
  height: 340px;
  width: 400px;
}
// /deep/.v-modal {
//   z-index: 0 !important;
// }
</style>
